import { inject, Injectable } from '@angular/core';
import { APIService } from '../APIService/api.service';
import { MrTranslatePipe } from 'src/app/pipes/mr-translate.pipe';
import { firstValueFrom } from 'rxjs';
import { TitleAndFileNames } from 'src/app/content/_components/_shared/mediaviewmodal/mediaviewmodal.component';
import { FileByNameFn, FilesByNamesFn, MediaApiFunc } from 'src/app/services/MediaApiFunc/abstract-media-api-func';

@Injectable({
  providedIn: 'root',
})
export class MangelMediaApiFuncService extends MediaApiFunc {
  private readonly mrTranslate = inject(MrTranslatePipe);
  private readonly apiService = inject(APIService);

  constructor() {
    super();
  }

  parseMediaPath(erfassung: string, rueckmeldung?: string): TitleAndFileNames[] {
    let fileNamesWithTitle: TitleAndFileNames[] = [];

    if (erfassung)
      fileNamesWithTitle.push({
        title: 'Mangel',
        fileNames: erfassung.split('|').filter(bild => bild != ''),
      });

    if (rueckmeldung)
      fileNamesWithTitle.push({
        title: 'Rückmeldung',
        fileNames: rueckmeldung.split('|').filter(bild => bild != ''),
      });

    return fileNamesWithTitle;
  }

  getApiFunctionMedia: FilesByNamesFn = async fileNames => {
    if (!fileNames?.length) return [];
    const { success, files, error } = await firstValueFrom(this.apiService.getMangelMediaAll(fileNames));
    if (!success)
      throw new Error(
        this.mrTranslate.transform('Die Dateien konnten nicht geladen werden!') +
          ' ' +
          this.mrTranslate.transform(error)
      );
    return files;
  };

  getApiFunctionMediaBig: FileByNameFn = async name => {
    if (!name) return;
    const base64 = await firstValueFrom(this.apiService.getMangelMedia(name));
    if (!base64) throw new Error(this.mrTranslate.transform('Die Datei konnte nicht geladen werden!'));
    return base64;
  };
}
